import React, { useState } from 'react';
import moment from 'moment';
import styled from '@emotion/styled';

const Content = styled.div`
  padding: 0 1.5rem;
  margin-bottom: 25px;

  h5 {
    cursor: pointer;
    color: #7e57c2;
  }
`;

const TechData = (props) => {
  const { code, date, ozonDate } = props;
  const [isShown, setIsShown] = useState(false);

  const handleVisibility = () => {
    setIsShown(!isShown);
  };

  return (
    <Content>
      <h5 onClick={handleVisibility}>Техническая информация {!isShown && '...'}</h5>
      {isShown && (
        <>
          <p>Код операции: {code}</p>
          <p>
            Дата выгрузки:{' '}
            {date !== undefined ? moment(date).format('DD.MM.YYYY HH:mm:ss') : 'Не установлена'}
          </p>
          <p>
            Дата ответа OZON:{' '}
            {ozonDate !== undefined
              ? moment(ozonDate).format('DD.MM.YYYY HH:mm:ss')
              : 'Не установлена'}
          </p>
        </>
      )}
    </Content>
  );
};

export default TechData;
